export default __webpack_public_path__ + "static/media/empty.9c815e5e.svg";